import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["id", "title", "description", "items", "className", "layoutType", "backgroundColor", "contentPosition", "image", "video", "onPlay", "titleTag", "data-test-id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { SiteVideo } from '@sbercloud/uikit-product-site-media';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { SectionTitle } from '../../helperComponents';
import { SectionBasic } from '../SectionBasic';
import styles from "./styles.module.css";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function SectionContentList(_ref) {
  var id = _ref.id,
    title = _ref.title,
    description = _ref.description,
    items = _ref.items,
    className = _ref.className,
    layoutType = _ref.layoutType,
    backgroundColor = _ref.backgroundColor,
    _ref$contentPosition = _ref.contentPosition,
    contentPosition = _ref$contentPosition === void 0 ? 'left' : _ref$contentPosition,
    image = _ref.image,
    video = _ref.video,
    onPlay = _ref.onPlay,
    titleTag = _ref.titleTag,
    _ref$dataTestId = _ref['data-test-id'],
    dataTestId = _ref$dataTestId === void 0 ? 'section-content-list' : _ref$dataTestId,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(SectionBasic, _objectSpread(_objectSpread({
    id: id,
    layoutType: layoutType,
    title: title,
    description: description,
    className: className,
    backgroundColor: backgroundColor,
    "data-test-id": dataTestId,
    titleTag: titleTag
  }, extractSupportProps(rest)), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.sectionContent,
      "data-layout-type": layoutType,
      "data-content-position": contentPosition,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.mediaWrapper,
        children: [image && /*#__PURE__*/_jsx("img", {
          className: styles.image,
          src: image.src,
          alt: image.alt || title || 'section-content-image',
          "data-test-id": "".concat(dataTestId, "__image")
        }), video && /*#__PURE__*/_jsx(SiteVideo, {
          video: video,
          onPlay: onPlay,
          layoutType: layoutType,
          "data-test-id": "".concat(dataTestId, "__video")
        })]
      }), items && items.length > 0 && /*#__PURE__*/_jsx("ul", {
        className: styles.list,
        children: items.map(function (item, index) {
          return /*#__PURE__*/_jsx("li", {
            className: styles.item,
            children: /*#__PURE__*/_jsx(SectionTitle, {
              layoutType: layoutType,
              title: item.title,
              titleLink: item.titleLink,
              description: item.description,
              titleSectionSize: "s",
              titleTag: "h3"
            })
          }, "".concat(title, "__").concat(index));
        })
      })]
    })
  }));
}